import React, { useMemo } from "react";
import { BriefcaseIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import { getTimeSlotsDuration, formatHoursAndMinutes } from "../utils/workTimeCount";

export default function V2TabellaTurnoGiornaliero({ selectedWorkingHour }) {
  const slots = useMemo(() => {
    return [...(selectedWorkingHour?.time_slots || [])].sort((a, b) =>
      (a.start_at || "").localeCompare(b.start_at || "")
    );
  }, [selectedWorkingHour]);

  const totalHours = getTimeSlotsDuration(slots);
  const totalWorkingTime = formatHoursAndMinutes(totalHours);

  if (!selectedWorkingHour) return null;

  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
      {/* Header */}
      <div className="bg-indigo-100 px-4 py-2">
        <div className="text-sm font-semibold uppercase text-indigo-800">
          Anteprima turno giornaliero
        </div>
        <div className="text-xs text-gray-500 mt-0.5">
          Fasce orarie e pause del turno selezionato
        </div>
      </div>

      {/* Body (più compatto) */}
      <div className="px-4 py-3 space-y-2">
        {slots.length === 0 ? (
          <div className="text-sm text-gray-500">Nessuna fascia oraria.</div>
        ) : (
          slots.map((slot) => (
            <div
              key={slot.id}
              className="rounded-lg border border-gray-100 bg-gray-50/50 px-3 py-2"
            >
              {/* Riga principale fascia */}
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0 flex items-center gap-2 text-sm font-semibold text-gray-800">
                  <BriefcaseIcon className="h-4 w-4 text-indigo-700 shrink-0" />
                  <span className="truncate">
                    {slot.start_at} - {slot.end_at}
                  </span>
                </div>
              </div>

              {/* Riga pause */}
              <div className="mt-0.5 flex flex-wrap items-center gap-1.5">
                <span className="inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-[11px] font-semibold text-indigo-700 border border-indigo-100">
                  <LocalBarIcon style={{ height: 12, width: 12, color: "#4f46e5" }} />
                  Pause
                </span>

                {Array.isArray(slot.breaks) && slot.breaks.length > 0 ? (
                  slot.breaks.map((br) => {
                    const hidden = br?.is_visible === false;
                    return (
                      <span
                        key={br.id}
                        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold border
                          ${
                            hidden
                              ? "bg-gray-100 text-gray-500 border-gray-200"
                              : "bg-white text-gray-700 border-gray-200"
                          }`}
                        title={hidden ? "Pausa nascosta" : "Pausa visibile"}
                      >
                        {hidden && <EyeSlashIcon className="h-3.5 w-3.5 text-gray-500" />}
                        {br.start_at} - {br.end_at}
                      </span>
                    );
                  })
                ) : (
                  <span className="text-[11px] text-gray-400 ml-1">Nessuna</span>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer (Totale in basso) */}
      <div className="flex items-center justify-between gap-3 bg-gray-50 px-4 py-2 border-t border-gray-200">
        <div className="text-xs font-semibold uppercase text-gray-700">Totale ore giornaliere</div>
        <div className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-[13px] font-semibold text-gray-800 border border-gray-200 uppercase">
          <span className="text-indigo-700">{totalWorkingTime}</span>
        </div>
      </div>
    </div>
  );
}